import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Features from './components/Features';
import Offer from './components/Offer';
import About from './components/About';
import Contact from './components/Contact';
import AI from './components/AI';

function App() {
  return (
    <>
    <Navbar/>
    <Header/>
    <Features/>
    <Offer/>
    <About/>
    <Contact/>
    <AI/>
    </>
  );
}

export default App;
